import { ILocation } from "../types/ILocation";

const extractLocations = (responseData: any): ILocation[] => {
	const locations: ILocation[] = [];



	for (const assigneeId in responseData) {
		const assigneeData = responseData[assigneeId];
		const appointments = assigneeData.appointments;

		for (const appointmentId in appointments) {
			const appointment = appointments[appointmentId];
		
			const { latitude, longitude } = appointment;

			if (latitude && longitude) {
				locations.push({
					latitude,
					longitude,
				});
			}
		}
	}



	return locations;
};

export { extractLocations };
